module.exports = __webpack_public_path__ + "static/media/mlh-logo-monochrome-yellow.0feca2bf.svg";